import DatasetViewModel from '../../services/category/view-model/DatasetViewModel';
import UniqueId from '../../services/uid/UniqueId';

// TODO: cache disabled/filtered children
export class RefreshRulesActionCollection<
  T = any,
> implements Iterable<T | null> {
  private list: Record<UniqueId, T> = {};
  private isLocked = false;

  constructor(private readonly datasets: DatasetViewModel[] = []) {}

  private findViewModel(datasetId: UniqueId): DatasetViewModel | undefined {
    return this.datasets.find(({ id }) => id === datasetId);
  }

  private getChildrenIds(inputId: UniqueId): UniqueId[] {
    const children: DatasetViewModel[] = this.datasets.filter(
      ({ parent }) => parent === inputId
    );

    const childrenOfChildren = children.reduce(
      (memo, { id }) => [...memo, ...this.getChildrenIds(id)],
      [] as UniqueId[]
    );

    return [...children.map(({ id }) => id), ...childrenOfChildren];
  }

  private getParentIds(inputId: UniqueId): UniqueId[] {
    const currentViewModel = this.findViewModel(inputId);

    if (!currentViewModel) {
      return [];
    }

    const currentParentId = currentViewModel.parent;

    if (!currentParentId) {
      return [];
    }

    return [currentParentId, ...this.getParentIds(currentParentId)];
  }

  private isParentAdded(viewModel: DatasetViewModel): boolean {
    const parents = this.getParentIds(viewModel.id);
    return Object.keys(this.list).some(savedId => parents.includes(savedId));
  }

  public add(datasetId: UniqueId, scheduledAction: any): void {
    if (this.isLocked) {
      return;
    }

    const viewModel = this.findViewModel(datasetId);

    if (!viewModel || this.isParentAdded(viewModel)) {
      return;
    }

    if (!viewModel.parent) {
      this.list = {};
      this.isLocked = true;
    }

    this.list[datasetId] = scheduledAction;

    for (const childId of this.getChildrenIds(viewModel.id)) {
      delete this.list[childId];
    }
  }

  public [Symbol.iterator](): Iterator<T | null> {
    let pointer = 0;
    const list = Object.values(this.list);

    return {
      next(): IteratorResult<T | null> {
        if (pointer < list.length) {
          return { done: false, value: list[pointer++] };
        } else {
          return { done: true, value: null };
        }
      },
    };
  }
}
